import { RichTextTypes } from 'ui-forms-components/constants/FieldTypeMapping';
export const getFieldUrlPath = ({
  formItemReference
}) => `${formItemReference ? `${encodeURIComponent(formItemReference)}` : ''}`;
export const parseFieldUrlPath = fieldUrlPath => {
  const isPathNumeric = !isNaN(Number(fieldUrlPath));
  const parsedFieldUrlPath = isPathNumeric ? Number(fieldUrlPath) : fieldUrlPath;
  return {
    formItemReference: parsedFieldUrlPath
  };
};
export const SELECTED_FROM_SOURCES = {
  NONE: 'NONE',
  SELECTED: 'SELECTED',
  FORM_FIELD: 'FORM_FIELD',
  IMAGE: 'IMAGE',
  RICH_TEXT: 'RICH_TEXT'
};
export const getSelectedFormItemSource = ({
  formItemReference,
  selectedFormItemType,
  formField,
  richText
}) => {
  if (!formItemReference && !selectedFormItemType) return SELECTED_FROM_SOURCES.NONE;
  if (selectedFormItemType) return SELECTED_FROM_SOURCES.SELECTED;
  if (formField) return SELECTED_FROM_SOURCES.FORM_FIELD;
  if (richText && !richText.content) return SELECTED_FROM_SOURCES.NONE;
  if (richText && richText.type && richText.type === RichTextTypes.IMAGE) return SELECTED_FROM_SOURCES.IMAGE;
  if (richText) return SELECTED_FROM_SOURCES.RICH_TEXT;
  return SELECTED_FROM_SOURCES.SELECTED;
};